import { Link } from 'react-router-dom';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const fixImg = (url) => !url ? null : (url.startsWith('http') ? url : `${BACKEND}${url}`);

/**
 * BENTO — asymmetric 4-up grid: 1 big, 1 tall, 2 small. Visually dense and editorial.
 * Uses CSS grid areas so each tile sits in its own box.
 */
export default function BentoBlock({ category, articles }) {
  if (!articles?.length) return null;
  const color = category?.color || '#dc2626';
  const [a, b, c, d] = articles.slice(0, 4);

  const Tile = ({ art, area, size = 'md', overlay = false }) => {
    if (!art) return null;
    const textSize = size === 'lg' ? 'text-2xl' : size === 'sm' ? 'text-sm' : 'text-base';
    return (
      <Link to={`/clanak/${art.slug}`} data-testid={`bento-${area}`}
            className={`group relative block rounded-xl overflow-hidden bg-white dark:deep-black-card border border-transparent dark:border-white/5 ${overlay ? 'text-white' : ''}`}
            style={{ gridArea: area }}>
        {fixImg(art.cover_image_url) && (
          <img src={fixImg(art.cover_image_url)} alt={art.title_hr} loading="lazy"
               className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        )}
        {overlay && <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />}
        <div className={`relative ${overlay ? 'absolute bottom-0 left-0 right-0 p-4' : 'p-4 bg-white/95 dark:bg-[#0a0a12]/95 mt-auto'} ${overlay ? '' : 'h-full flex flex-col justify-end min-h-[120px]'}`}>
          <span className={`inline-block text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm mb-2 ${overlay ? '' : ''}`}
                style={{ backgroundColor: color }}>{category.name_hr}</span>
          <h3 className={`${textSize} font-bold leading-tight line-clamp-3 ${overlay ? 'text-white' : 'text-gray-900 dark:text-gray-50 group-hover:text-red-600 dark:group-hover:text-red-400 transition-colors'}`}>
            {art.title_hr}
          </h3>
        </div>
      </Link>
    );
  };

  return (
    <div className="grid gap-4" data-testid="bento-block"
         style={{
           gridTemplateAreas: `
             "lead lead tall"
             "lead lead tall"
             "sm1  sm2  tall"
           `,
           gridTemplateColumns: '1fr 1fr 1fr',
           gridTemplateRows: '140px 100px 140px',
         }}>
      <Tile art={a} area="lead" size="lg" overlay />
      <Tile art={b} area="tall" size="md" overlay />
      <Tile art={c} area="sm1" size="sm" />
      <Tile art={d} area="sm2" size="sm" />
    </div>
  );
}
